"use client";

import { createBrandContext } from "@repo/dashboard-core/context";

import type { PdfBrandConfig } from "@/config/brand";

export const { BrandProvider, useBrand } = createBrandContext<PdfBrandConfig>();
